export const API_BASE_URL = 'http://localhost/veterans-qms/back/api';